module.exports = __webpack_public_path__ + "static/media/oval.c651ea9f.svg";